import { DraftConfiguration, DraftState } from '@/types';
import { equalizeOnAdd } from './equalizeOnAdd';

export const addConfigurationToDraft = (draft: DraftState, configuration: DraftConfiguration) => {
  draft.configurationIds.push(configuration.cid);
  draft.configurations[configuration.cid] = configuration;
  draft.selectedConfigurationId = configuration.cid;

  equalizeOnAdd(draft, configuration);
};
